export class ConfigurationModel {
    constructor() {
        this.clientId = "";
        this.clientSecret = "";
        this.authURL = "";
        this.baseURL = "";
        this.refreshToken = "";
        this.grantType = "";
    }
}
export default class Configuration extends ConfigurationModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
